import { render, staticRenderFns } from "./ShowAnnouncement.vue?vue&type=template&id=0a201f10&scoped=true&"
import script from "./ShowAnnouncement.vue?vue&type=script&lang=js&"
export * from "./ShowAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./ShowAnnouncement.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ShowAnnouncement.vue?vue&type=style&index=1&id=0a201f10&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a201f10",
  null
  
)

export default component.exports